module.exports = __webpack_public_path__ + "static/media/widget-no-data.9bcfe74c.svg";